export const invoiceStatusFilter = {
  all: null,
  due: 1,
  paid: 3,
};

export const invoiceTypeFilter = {
  all: null,
  'service-plan': 1,
  job: 2,
};
